var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formComponent)?_c(_vm.formComponent,{ref:"form$",tag:"component",attrs:{"form":_vm.formData},on:{"mounted":_vm.handleFormMounted}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }